import React from 'react';
import PropTypes from 'prop-types';

import { MobileStepper as MuiMobileStepper } from '@material-ui/core';

const MobileStepper = ({ steps, ...rest }) =>  <MuiMobileStepper steps={steps} {...rest}/>

MobileStepper.propTypes = {
  steps: PropTypes.number.isRequired,
}

export default MobileStepper;



// WEBPACK FOOTER //
// ./src/components/base/MobileStepper/MobileStepper.js